module.exports = __webpack_public_path__ + "img/cb9-l-110.b21b7022.gif";